<template>
  <div style="background-color:#6D94CD; width:100%; height:100%;" class="pa-3">
    

    <v-form ref="form">
      <v-col>
        <v-text-field label="Nome *" placeholder="Nome" v-model="request.nome" :rules="[vincoli.required]" class="rounded-sm custom-color-error custom-placeholer-color" outlined dense dark></v-text-field>
        
        <v-text-field label="Cognome *" placeholder="Cognome" v-model="request.cognome" :rules="[vincoli.required]" class="rounded-sm custom-color-error custom-placeholer-color" outlined dense dark></v-text-field>
        
        <!-- <v-text-field label="Azienda" v-model="request.azienda" ></v-text-field> -->
        
        <v-row>
          <v-col xs12 px-3>
            <v-alert style="font-size: 13px; padding: 5px 16px !important;" color="white" v-if="alertType" :type="alertType" :value="true" outlined>
              <span v-html="message"></span>
            </v-alert>
          </v-col>
        </v-row>
        
        <v-text-field persistent-hint :hint="emailHint" label="Email *" placeholder="Email" v-model="request.email" :rules="[vincoli.required]" class="rounded-sm custom-color-error custom-placeholer-color" outlined dense dark>
          <template v-slot:message="{ message }">
            <span v-html="message"></span>
          </template>
        </v-text-field>

        <v-text-field persistent-hint :hint="telefonoHint" label="Telefono" placeholder="Telefono" type="tel" maxlength="15" v-model="request.telefono" :rules="[vincoli.isNumber]" class="rounded-sm custom-color-error custom-placeholer-color" outlined dense dark>
          <template v-slot:message="{ message }">
            <span v-html="message"></span>
          </template>
        </v-text-field>
        
        <v-checkbox v-model="accettoCondizioni" :rules="[vincoli.accettoCondizioni]" class="mt-0 custom-color-error" :color="scdOrange" dark>
          <template v-slot:label style="margin-bottom: 0 !important;">
            <span :style="condizioniGeneraliStyle">Accetto le&nbsp;</span>
            <a href="https://simulatoreclickday.it/ccg/" 
            target="_blank" 
            @click.stop class="text-decoration-underline font-italic"
            :style="condizioniGeneraliStyle"
            >
              Condizioni Generali
            </a>
          </template>
        </v-checkbox>
        <!-- <div class="subheading pt-4" style="color: white">Ti invieremo le <b>Credenziali di Accesso</b> all'indirizzo email da te indicato!</div> -->
      </v-col>
      
      <v-row justify="center">
        <v-btn @click="registraProvaGratuita()" :color="scdOrange" dark class="rounded-sm" large>
          Richiedi Prova Gratuita
        </v-btn>
      </v-row>
      <v-row justify="center" class="mt-3" v-if="isLoading">
        <v-progress-circular indeterminate :color="scdColor"></v-progress-circular>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import mixin from '../mixins';

export default {
  data() {
    return {      
      alertType: null,
      message: null,
      isLoading: false,

      request: {
        nome: null,
        cognome: null,
        // azienda: null,
        email: null,
        telefono: null
      },
      emailHint: '<span class="custom-hint">Ti invieremo le credenziali di accesso a questo indirizzo</span>',
      telefonoHint: '<span class="custom-hint">Se vuoi ricevere supporto telefonico</span>',
      accettoCondizioni: false,
      condizioniGeneraliStyle: 'color: #fff;'
    };
  },
  watch: {
    accettoCondizioni: function() {    
      this.changeCondizioniGeneraliStyle();
    }
  },
  methods: {
    changeCondizioniGeneraliStyle() {
      if (this.accettoCondizioni == false){ 
        // this.condizioniGeneraliStyle = `color: ${this.scdLightOrange};`;
        this.condizioniGeneraliStyle += 'font-weight: bold;';
      } else if (this.accettoCondizioni == true){
        // this.condizioniGeneraliStyle = `color: #fff;`;
        this.condizioniGeneraliStyle += 'font-weight: normal;';
      }
    },

    registraProvaGratuita: function() {
      this.changeCondizioniGeneraliStyle();

      if(!this.$refs.form.validate()){
        return;
      }

      // Valido separatamente l'email (per non avere "Email non valida" appena si inizia a scrivere)
      if(!/.+@.+/.test(this.request.email)){
        this.alertType = "error";
        // this.message = "Hai inserito un'email non valida. Riprova!";
        this.message = "Email non valida. Riprova!"; // Messaggio breve per risolvere velocemente problemi di spazio
        return;
      }

      this.isLoading = true;

      axios
        .post("/api/provaGratuita", this.request)
        .then(response => {
          if (response.data.hasError) {
            this.alertType = "error";
            this.message = response.data.messages[0];
          } else {
            // Inserita la redirect alla ty page, non è più necessario mostrare il messaggio
            // this.alertType = "success";
            // this.message = "Abbiamo inviato un'email a " + this.request.email + " con i dati di accesso al Simulatore Click Day!";

            window.parent.postMessage(true, "*");
          }
        })
        .catch(error => {
          this.alertType = "error";
          this.message = "Si è verificato un errore. Riprova";
        })
        .finally(() => {
          this.isLoading = false;
        });
      
    }
  }

};
</script>

<style lang="scss" scoped>
  .custom-color-error ::v-deep .v-messages__message,
  .custom-color-error ::v-deep .error--text,
  .custom-color-error.error--text {
    color: #FFF !important;
    caret-color: #FFF !important;

    // color: #EE9960 !important;
    // caret-color: #EE9960 !important;

    // color: #F08339 !important;
    // caret-color: #F08339 !important;
  }

  .custom-color-error ::v-deep .v-messages__message {
    font-weight: bold;
    // color: #EE9960 !important;
  }

  ::v-deep .custom-hint {
    font-weight: normal;
    color: hsla(0,0%,100%,.70);
  }

  // ::v-deep .v-input__control {
  //   margin-bottom: 5px!important;
  // }

  .custom-placeholer-color ::v-deep input::placeholder {
    color: #6D94CD!important;
  }
</style>